import { render, staticRenderFns } from "./PriceHistoryModal.vue?vue&type=template&id=52984866&scoped=true"
import script from "./PriceHistoryModal.vue?vue&type=script&lang=js"
export * from "./PriceHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./PriceHistoryModal.vue?vue&type=style&index=0&id=52984866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52984866",
  null
  
)

export default component.exports